import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import cx from 'classnames';
import { PureComponent } from 'react';
import { connect } from 'react-redux';

import { inviteUser } from '@/actions/invitation';
import { notify } from '@/actions/ui';
import { RootState } from '@/store';
import { lightTan, red500 } from '@/theme/colors';

import FAIcon from '../Icon/FAIcon';
import Link from '../Link';
import Picture from '../Picture';
import { Select } from '../Select/Select';
import s from './ProjectMember.module.scss';

const roleText = {
  manager: 'Research Manager',
  associate: 'Recruiting Associate',
  owner: 'Owner',
  member: 'Member',
};

function rolesFor(role: any) {
  if (!role) return [];
  switch (role) {
    case 'super-user':
    case 'manager':
    case 'associate':
      return ['manager', 'associate', 'owner', 'member'];
    case 'owner':
      return ['owner', 'member'];
    case 'member':
      return ['member'];
    default:
      throw new Error(`unsupported role ${role}`);
  }
}

function isInternal(role: any) {
  return role === 'manager' || role === 'associate';
}

const inviteButtonStyle = {
  style: {
    lineHeight: '16px',
    height: '16px',
    minWidth: 0,
    textTransform: 'capitalize',
    paddingLeft: 0,
    paddingRight: 0,
  },
};

class ProjectMember extends PureComponent {
  state = {
    resendInviteAvailable: true,
  };

  handleRemoveClick = () => {
    // @ts-expect-error TS(2339): Property 'removeMember' does not exist on type 'Re... Remove this comment to see the full error message
    const { removeMember, groupId, member } = this.props;
    removeMember(groupId, member.id);
  };

  // @ts-expect-error TS(7031): Binding element 'role' implicitly has an 'any' typ... Remove this comment to see the full error message
  handleRoleChange = ({ target: { value: role } }) => {
    // @ts-expect-error TS(2339): Property 'updateMember' does not exist on type 'Re... Remove this comment to see the full error message
    const { updateMember, groupId, member } = this.props;

    updateMember(groupId, member.id, { role, state: 'active' });
  };

  handleReinvite = () => {
    // @ts-expect-error TS(2339): Property 'member' does not exist on type 'Readonly... Remove this comment to see the full error message
    const { member, inviteUser, projectId, notify } = this.props;
    if (member.new) {
      throw new Error('cannot re-invite members not yet added');
    }
    this.setState({ sendingInvite: true });
    return inviteUser(
      {
        collectionType: 'project',
        collectionId: projectId,
        email: member.email,
        role: member.role,
      },
      { reinvite: true }
    ).then(
      () => {
        this.setState({ sendingInvite: false, resendInviteAvailable: false });
        notify('Invitation sent.');
      },
      () => {
        this.setState({ sendingInvite: false, resendInviteAvailable: false });
        notify('Unable to resend invite', 'error');
      }
    );
  };

  render() {
    // @ts-expect-error TS(2339): Property 'viewerRole' does not exist on type 'Read... Remove this comment to see the full error message
    const { viewerRole, member, key } = this.props;
    const { email, user, role, state } = member;
    const { html_url: htmlUrl, name } = user || {};

    const isInvitation = !user;
    const isInvitationSent = isInvitation && !member.new;
    const isDenied = state === 'denied';

    // @ts-expect-error TS(2339): Property 'sendingInvite' does not exist on type '{... Remove this comment to see the full error message
    const { sendingInvite, resendInviteAvailable } = this.state;

    const roles = rolesFor(viewerRole);
    const canRemove = roles.includes(role);

    let roleOptions = [];
    if (isDenied) {
      roleOptions.push({ value: 'denied', label: 'Denied' });
    }
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    roleOptions.push({ value: role, label: roleText[role] });
    roleOptions = [
      ...roleOptions,
      ...roles
        .filter((r) => r !== role)
        // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        .map((r) => ({ value: r, label: roleText[r] })),
    ];

    return (
      <div key={key} className={cx(s.root, { [s.denied]: isDenied })}>
        <Picture user={user} ring={isInternal(role)} size={40} />
        <div className={s.body}>
          <div className={s.header}>
            {isInvitation ? (
              <div>
                <h3 className={s.name}>{email}</h3>
                {isInvitationSent && (
                  <div className={s.invited}>
                    Invite Sent.{' '}
                    {resendInviteAvailable && (
                      // @ts-expect-error TS(2769): No overload matches this call.
                      <Button
                        secondary
                        label={sendingInvite ? 'Sending...' : 'Resend'}
                        disabled={sendingInvite}
                        {...inviteButtonStyle}
                        onClick={this.handleReinvite}
                      />
                    )}
                  </div>
                )}
              </div>
            ) : (
              <Link to={htmlUrl}>
                <h3 className={s.name}>{name}</h3>
              </Link>
            )}
          </div>
        </div>
        <div className={s.actions}>
          {roles.length > 1 ? (
            <Select
              sort={false}
              margin="dense"
              value={isDenied ? state : role}
              style={{ width: 200 }}
              onChange={this.handleRoleChange}
              options={roleOptions}
            />
          ) : (
            <div className={s.unchangeableRole}>
              {isDenied ? 'Member denied' : roleText[role as keyof typeof roleText]}
            </div>
          )}
          <IconButton
            style={{ marginRight: -12 }}
            disabled={!canRemove}
            onClick={this.handleRemoveClick}
          >
            <FAIcon
              icon="trash-o"
              style={{
                color: canRemove ? red500 : lightTan,
                fontSize: 20,
              }}
            />
          </IconButton>
        </div>
      </div>
    );
  }
}

export default connect(
  (state: RootState) => ({
    viewer: state.viewer,
  }),
  {
    notify,
    inviteUser,
  }
)(ProjectMember);
